<p>CPG dashboard works!</p>
